/**
 * Shared user-facing strings for GPS error codes written by Android.
 * Used both by the GPS request hook and the device status dashboard so the
 * mapping stays in one place.
 */

import { GpsError } from '@/types';

/** Long-form description suitable for tooltips, banners, and hook errors */
export const GPS_ERROR_MESSAGES: Record<GpsError['code'], string> = {
  permission_denied: 'Location permission not enabled on device',
  gps_disabled: 'GPS is turned off on device',
  timeout: 'Could not get precise GPS fix',
  error: 'GPS error on device',
};

/** Short label suitable for status icon tags (a few characters wide) */
export const GPS_ERROR_TAG_TEXTS: Record<GpsError['code'], string> = {
  permission_denied: 'No permission',
  gps_disabled: 'GPS off',
  timeout: 'Timeout',
  error: 'GPS error',
};

/** Lookup helper that gracefully degrades for unknown codes */
export function getGpsErrorMessage(code: string | undefined): string {
  if (!code) return GPS_ERROR_MESSAGES.error;
  return GPS_ERROR_MESSAGES[code as GpsError['code']] ?? GPS_ERROR_MESSAGES.error;
}

/** Lookup helper for the tag text */
export function getGpsErrorTagText(code: string | undefined): string {
  if (!code) return GPS_ERROR_TAG_TEXTS.error;
  return GPS_ERROR_TAG_TEXTS[code as GpsError['code']] ?? GPS_ERROR_TAG_TEXTS.error;
}
